import { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';

import TokenRequired from '../../../layout/Platform/InvoicesIntegration/TokenRequired/TokenRequired';
import Context from '../../../store/context';
import { AskInvoicesIntegration } from '../../../components';
import WelcomeMelo from '../../../pages/welcomeMelo/WelcomeMelo';
import useMeloLocation from './useMeloLocation';

const useFirstTimeModals = () => {
  const {
    modal: { showModal, hideModal }
  } = useContext(Context);

  const { businessId, businesses } = useSelector(state => state.userData);
  const {
    dianConnections,
    druoAccounts,
    //showDIANConnectionModal,
    businessDemographyIsComplete
  } = businesses[businessId];

  const { currentPathAvoidModals } = useMeloLocation();

  useEffect(() => {
    if (currentPathAvoidModals) return;
    if (!businessDemographyIsComplete) {
      showModal(<WelcomeMelo />, true);
    } /*  else {
      if (showDIANConnectionModal) {
        showModal(
          <AskInvoicesIntegration
            title='Activa la sincronización de cuentas de cobro con la DIAN'
            description='Traemos de manera automática las cuentas de cobro electrónicas de la DIAN con la información básica de los proveedores. Ingresa las credenciales de la DIAN y durante 30 minutos cada 24 horas se actualizarán las cuentas de cobro después de ingresar el token que te llegará al correo.'
          />,
          false
        );
      } elseif (dianConnections[0]?.status ? dianConnections[0]?.status !== 'valid' : false) {
        showModal(<TokenRequired hideModal={hideModal} />, false);
      }
    } */ 
  }, [
    businessDemographyIsComplete,
    currentPathAvoidModals,
    dianConnections,
    druoAccounts,

    showModal
  ]);
};

export default useFirstTimeModals;

// console.log({ showBankConnectionModal });
// if (showBankConnectionModal) {
/*  showModal(
        <AskPaymentsIntegration
          askInvoicesDian={askInvoicesDian}
          title='Realizar integracion con el banco'
          description={
            <span>
              DRUO nos permite conectarnos a tu cuenta bancaria de manera segura. Al hacer click en conectar, autorizas a Melo para que
              se dispersen los pagos que han sido realizados por ti.
              <a
                href='https://uploads-ssl.webflow.com/61ee125cef4206240be09812/63447a02e7b89d1055e05acc_TERMINOS-Y-CONDICIONES-PARA-EL-USO-DE-LA-PLATAFORMA-MELO.docx.pdf'
                target='_blank'
                rel='noreferrer'>
                {' '}
                Términos y Condiciones
              </a>
            </span>
          }
        />
      ); */
// } else {
// askInvoicesDian();
// }
// eslint-disable-next-line react-hooks/exhaustive-deps
/**
       const askInvoicesDian = useCallback(() => {
    // return;
    if (currentPathAvoidModals) return;
    if (!businessDemographyIsComplete || !sourceBankAccountIsConnected) {
      showModal(<WelcomeNotRegister />, false);
    } else {
      if (showDIANConnectionModal) {
        showModal(
          <AskInvoicesIntegration
            title='Activa la sincronización de cuentas de cobro con la DIAN'
            description='Traemos de manera automática las cuentas de cobro electrónicas de la DIAN con la información básica de los proveedores. Ingresa las credenciales de la DIAN y durante 30 minutos cada 24 horas se actualizarán las cuentas de cobro después de ingresar el token que te llegará al correo.'
          />,
          false
        );
      } else if (dianConnections[0]?.status ? dianConnections[0]?.status !== 'valid' : false) {
        showModal(<TokenRequired hideModal={hideModal} />, false);
      }
    }
  }, [
    currentPathAvoidModals,
    dianConnections,
    hideModal,
    showDIANConnectionModal,
    showModal,
    businessDemographyIsComplete,
    sourceBankAccountIsConnected
  ]);
     */
